<template>
    <aside class="right-aside">
        <section class="content-header ">
            <h1>{{this.$route.meta.title}}</h1>
        </section>
        <section class="content">
            <slot></slot>
        </section>
    </aside>
</template>
<script>
export default {
    name: "right-side",
    methods: {

    }
}
</script>
<style lang="scss" scoped>
.right-aside {
    padding: 0 20px 10px 20px;
    width: 100%;
    max-width: 100%;
    min-height: 100vh;
    .content-header > h1 {
        margin: 2px;
        padding-left: 13px;
        padding-top: 12px;
        font-size: 0px;
        line-height: 1.5;
    }
    .content-header {
        display: none;
        margin: -2px -20px 25px -20px;
        height: 55px;
        background: #f9fafb ;
        box-shadow: 3px 1px 5px #ccc;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/right-side.vue